import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  message,
  Typography,
  Row,
  Col,
  Tag,
} from "antd";
import dataService from "../networks/api/service/dataService";
import moment from "moment";
import PrimaryButton from "../components/TableComponent/ButtonComponent/Buttons";
import CustomTable from "../components/TableComponent/CustomTable";
import DynamicExcelUpload from "../components/DynamicExcelUpload";
import { Switch } from 'antd';
import dayjs from "dayjs";
import colors from "../assets/styles/colour";

const { Option } = Select;
const { Title } = Typography;
function ManageUser() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [form] = Form.useForm();
  const [roles, setRoles] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Fetch all users from the API

  const getExcelData = async (formData) => {
    console.log(formData, "getExcelData");
    try {
      const res = await dataService.addBulkUser(formData);
      if (res.code === 200) {
        message.success(res.message);
      }
    } catch (e) {}
  };

  const getUsers = async () => {
    try {
      setLoading(true);
      const res = await dataService.getAllUsers();
      if (res.code === 200) {
        setUsers(res.data);
        setFilteredData(res.data); // Ensure filteredData has initial data
      } else {
        message.error("Failed to fetch users");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while fetching users");
    } finally {
      setLoading(false);
    }
  };

  const getUserRoles = async () => {
    try {
      setLoading(true);
      const res = await dataService.getAllUserRoles();
      if (res.code === 200) {
        setRoles(res.data);
      } else {
        message.error("Failed to fetch user roles");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while fetching user roles");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
    getUserRoles();
  }, []);

  const handleSearch = (value) => {
    setSearchTerm(value); // Store search term
    if (!value.trim()) {
      setFilteredData(users); // Reset if search input is empty
      return;
    }

    const filtered = users.filter((user) =>
      ["name", "role"].some(
        (key) =>
          user[key] && user[key].toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered);
  };

  // Open modal for adding or editing user
  const openModal = (user = null) => {
    setIsEditing(!!user);
    setCurrentUser(user);
    if (user) {
      form.setFieldsValue({
        ...user,
        dob: moment(user.dob, "DD-MM-YYYY"),
      });
    } else {
      form.resetFields();
    }
    setIsModalVisible(true);
  };

  // Handle form submission
  const handleFormSubmit = async (values) => {
    console.log(values,"valuesvalues",currentUser)
    try {
      const payload = {
        ...values,
        dob: values.dob.format("DD-MM-YYYY"),
        email:  currentUser?.email?.includes("@") ? currentUser.email : values.email,

      };

      if (isEditing) {
        console.log("update");
        const res = await dataService.editUser(currentUser._id, payload);
        // message.success("User updated successfully");
      } else {
        const res = await dataService.addUser(payload);
        message.success("User added successfully");
      }

      setIsModalVisible(false);
      getUsers();
    } catch (error) {
      console.error(error);
      message.error("An error occurred while saving user data");
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "Email/Mobile",
      dataIndex: "email",
      key: "email",
       align: "center",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
       align: "center",
      render: (text) => (text === "Constituency" ? "Parliament" : text),
    },
    {
      title: "Actions",
      key: "actions",
       align: "center",
      render: (_, record) => (
        <Button
          type="link"
          style={{ color: "#fa8c16" }}
          onClick={() => openModal(record)}
        >
          Edit
        </Button>
      ),
    },
    {
  title: "Status",
  dataIndex: "isActive",
  key: "status",
  align: "center",
  render: (isActive) => {
    return isActive ? (
      <Tag color="green">Active</Tag>
    ) : (
      <Tag color="red">Inactive</Tag>
    );
  },
},
  ];

  return (
    <div>
      <Title level={3} style={{ color: "#0b023d", marginBottom: "20px" }}>
        Manage Users
      </Title>

      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: "16px" }}
      >
        <Col>
          <Button style={{backgroundColor: colors.button, color: colors.textPrimary}} onClick={() => openModal()}>
            Add User
          </Button>
        </Col>
        <Col>
          <Input.Search
            placeholder="Search User"
            allowClear
            value={searchTerm} // Ensure the value updates correctly
            onChange={(e) => handleSearch(e.target.value)}
            onSearch={(value) => handleSearch(value)}
            style={{ width: "100%", maxWidth: 200 }}
          />
        </Col>
      </Row>
      <div style={{ marginBottom: "20px" }}>
        <CustomTable
          columns={columns}
          dataSource={filteredData} // Make sure this is used
          loading={loading}
          rowKey={(record) => record._id}
          pagination={{ position: ["bottomCenter"], pageSize: 5 }}
          bordered
          size="middle"
          style={{
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            backgroundColor: "#fff",
            width: "100%",
            overflowX: "auto",
          }}
          scroll={{ x: 800 }}
        />
      </div>
      <div>
        Bulk Upload :
        <DynamicExcelUpload getExcelData={getExcelData} />
      </div>

      <Modal
        title={isEditing ? "Edit User" : "Add User"}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={() => form.submit()}
      >
        <Form form={form} onFinish={handleFormSubmit} layout="vertical">
          <Form.Item
            name="name"
            label="Name"
            rules={[
              { required: true, message: "Please enter the user's name" },
              {
                pattern: /^[A-Za-z\s]+$/,
                message: "Only letters and spaces are allowed",
              },
            ]}
          >
            <Input />
          </Form.Item>

          {!isEditing && (
            <Form.Item
              name="email"
              label="Email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "Please enter a valid email",
                },
              ]}
            >
              <Input />
            </Form.Item>
          )}

          {!isEditing && (
            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: "Please enter the password" }]}
            >
              <Input.Password />
            </Form.Item>
          )}

          <Form.Item
            name="mobileNumber"
            label="Mobile Number"
            rules={[
              { required: true, message: "Please enter the mobile number" },
              {
                pattern: /^[0-9]{10}$/,
                message: "Please enter exactly 10 digits",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="dob"
            label="Date of Birth"
            rules={[{ required: true, message: "Please select date of birth" }]}
          >
            <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} disabledDate={(current) => current && current >= dayjs().endOf("day")}/>
          </Form.Item>

          <Form.Item
            name="gender"
            label="Gender"
            rules={[{ required: true, message: "Please select gender" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              style={{ border: "1px solid grey", borderRadius: 5 }}
              placeholder="Select gender"
            >
              <Option value="male">Male</Option>
              <Option value="female">Female</Option>
              <Option value="other">Other</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="address"
            label="Address"
            rules={[{ required: true, message: "Please enter the address" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="role"
            label="Role"
            rules={[{ required: true, message: "Please select the role" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              style={{ border: "1px solid grey", borderRadius: 5 }}
              placeholder="Select role"
            >
              {roles?.map((item) => (
                <Option key={item._id} value={item.roleName}>
                  {item.roleName === "CONSTITUENCY"
                    ? "PARLIAMENT"
                    : item.roleName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
  name="isActive"
  label="Active Status"
  valuePropName="checked"
>
  <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
</Form.Item>

        </Form>
      </Modal>
    </div>
  );
}

export default ManageUser;
